import moment from 'moment'
import * as yup from 'yup'

export const naturalPersonSchema = yup.object({
  cpf: yup
    .string()
    .required('REQUIRED_FIELD')
    .min(14, 'INCOMPLETE_FIELD')
    .nullable(),
  personType: yup.string().required('REQUIRED_FIELD'),
  name: yup
    .string()
    .required('REQUIRED_FIELD')
    .matches(
      /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u,
      'INVALID_NAME'
    ),
  email: yup.string().email('INVALID_EMAIL').required('REQUIRED_FIELD'),
  birthdate: yup
    .string()
    .required('REQUIRED_FIELD')
    .test('isValidDate', 'INVALID_DATE', (value) =>
      moment(
        moment(`${value}`, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
      ).isValid()
    )
    .test('maxData', 'FUTURE_DATE_ERROR', (value) =>
      moment(
        moment(`${value}`, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
      ).isBefore(moment().add(1, 'd'), 'day')
    )
    .test('18YearsOld', 'UNDERAGE_ERROR', (value) =>
      moment(value, 'DD/MM/YYYY').isSameOrBefore(
        moment().subtract(18, 'years'),
        'day'
      )
    ),
  rg: yup
    .string()
    .required('REQUIRED_FIELD')
    .matches(/^[ 0-9a-zA-Z.\-\b]+$/, 'INVALID_FIELD'),
  phone: yup.string().required('REQUIRED_FIELD'),
  linkedin: yup.string().notRequired().nullable(),
  cep: yup.string().required('REQUIRED_FIELD').min(9, 'INCOMPLETE_FIELD'),
  street: yup.string().required('REQUIRED_FIELD'),
  complement: yup.string().optional().nullable(),
  city: yup.string().required('REQUIRED_FIELD'),
  state: yup.string().required('REQUIRED_FIELD'),
  neighborhood: yup.string().required('REQUIRED_FIELD'),
  addressNumber: yup
    .string()
    .required('REQUIRED_FIELD')
    .matches(/^[0-9]+$/, 'INVALID_NUMBER'),
})
